import React, { useEffect, useState } from "react";
import { Table } from "antd";
import axios from "axios";
import { transactionColumns } from "../columns/transactionColumns";
import { LedgerResponsiveWrapper, API_BASE, getArn } from "../LedgerResponsive";

export default function TransactionTable({ folio, pan, schemeCode, onOpenModal }) {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!folio || !pan || !schemeCode) return;
    setLoading(true);

    axios
      .get(
        `${API_BASE}/get_transactions.php?pan=${pan}&folio_number=${folio}&scheme_code=${schemeCode}&arn_no=${getArn()}`
      )
      .then((res) => {
        console.log("👉 Transactions API Response:", res.data);
        if (res.data && Array.isArray(res.data.transactions)) {
          setTransactions(res.data.transactions);
        } else {
          setTransactions([]);
        }
      })
      .catch((err) => {
        console.error("❌ Transactions API Error:", err);
        setTransactions([]);
      })
      .finally(() => setLoading(false));
  }, [folio, pan, schemeCode]);

  return (
    <LedgerResponsiveWrapper>
      <Table
        loading={loading}
        columns={transactionColumns(onOpenModal)}
        dataSource={transactions}
        rowKey="id"
        pagination={false}
        bordered
        // ❌ expandable हटा दिया ताकि plus icon गायब हो जाए
      />
    </LedgerResponsiveWrapper>
  );
}
